<svelte:head>

	{#if $activity && $activity.settings}
		<title>{$activity.titles[0]}</title>
	<meta name='description' content='{$activity.settings.desc}'>

	<meta name="twitter:site" content="@mspanish">
	<meta name="twitter:title" content="{$activity.titles[0]}">
	<meta name="twitter:description" content="no way dude">
	<meta name="twitter:creator" content="@mspanish">
	<meta name="twitter:image" content="{$activity.settings.img.replace('../', 'https://talker.netlify.com/')}">
	
	<meta property="og:title" content="{$activity.titles[0]}" />
	<meta property="og:type" content="article" />
	<meta property="og:url" content="https://talker.netlify.com/{$activity.settings.name}.html" />
	<meta property="og:image" content="{$activity.settings.img.replace('../', 'https://talker.netlify.com/')}" />
	<meta property="og:description" content="{$activity.settings.desc}" />
	
	{/if}
</svelte:head>


<div id="postWrap" class="content is-medium">
{#if details} 
  <h1 id="post" style="background-color:{colors.color1}">{details[1].menu}</h1>
{/if} 

{#if details && details[1].tips}
<blockquote style="border-left-color: {colors.color1}; border-right-color: {colors.color2};">
	<h3>key features</h3>
	<ol>
		{#each details[1].tips as tip}
			<li>{@html tip}</li>
		{/each}
	</ol>
</blockquote>
{/if} 

{#if $id.includes('activities')}
<div class="activityHeader">
<h1>{#if $activity &&  $activity.settings}
	{$activity.settings.desc}
	{:else} 
	'AAC Activities by Stacey Reiman'
{/if}
</h1>
</div>


{/if}  

<div class="content is-large desc">
{#if $id.includes('activities')}
<span class="tag"><a href="../activities">← activities list</a></span>
{/if}

	{#if lessonTags}
		{#each lessonTags as tag}
		<span class="tag">
			<a href="#{tag.id}">
				{tag.text}
			</a>
		</span> 
		{/each}  
	{/if}
	

	<section transition:fade>
	{#if $id.includes('activities')}
		<Sharing bind:activity=$activity/>
	{/if}
	
	{@html desc}
	
	
	</section>


	

</div>
	</div>


{#if $id.includes('activities')}
<span class="tag"><a href="../activities">← activities list</a></span>
{/if}


<style>
.activityHeader{
margin-bottom: 20px;
}
blockquote {
	border-bottom-right-radius:4px;
	border-bottom-left-radius:4px;
	text-align: initial;
}
blockquote::before {
	content: '☼';
	font-size: 4rem;
}
#postWrap {
	padding-bottom:50px;
}

ol > li {
	font-size: 1.5rem;
	word-spacing: 5px;
    letter-spacing: .5px;
}

h1 {
		padding: 10px;
		padding-left: 50px;
		color:  white;
		border-radius: 4px;
		border-bottom-right-radius:0;
		border-bottom-left-radius:0;
		margin-bottom:0;
		margin-top: 5px;
		box-shadow: 2px 2px 15px #ccc;
		-webkit-text-fill-color: white;
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: black;
    -webkit-text-stroke-width: .2px;
    word-spacing: 15px;
	letter-spacing: 2px;		
	font-family: 'Luckiest Guy';
	}
h3 { 
	font-size: 2rem;
	margin-left:20px;
} 

</style> 

<script >
  import { fade } from 'svelte-transitions';	
  import roadtrip from 'roadtrip';		
  import Sharing from '../../components/Sharing.html';

 
  export default {
	transitions: { fade },
    store: () => store,
    components:{ Sharing
	},  
    methods: {
		createSettings(id) {
			// for pages that are NOT  activities,  but still need an $activity in the store so they can have the correct tags. That way I can remove this from the render.js process
		let title = document.getElementsByTagName('h2')[0]
		if (title) {
			title = title.textContent
		}
		else {
			title = "AAC Talker: Devices, Graphics, and Articles for Nonverbal Children"; 
		}
		let img = document.getElementsByTagName('img')[0];
		if (img) {
			img = img.getAttribute('src')
		}
		else {
			img = "https://talker.netlify.com/img/talker_symbols/go.png";
		}
		
		let desc = document.getElementsByTagName('p')[0] 
		
		if (desc) {
			desc = desc.innerHTML;
			desc=  desc.substring(0,100);
		}
		else {
			desc = "AAC resources for parents, therapists, and families looking for ideas for nonverbal and minimally verbal children.";
		}
		
		let activity = {
		"titles":[title],
		"subs":[],
		"file":{
			"value":id+".html",
			"done":false},
		"tags":[],
		"dateRaw":"2019-02-24T00:54:40.771Z",
		"date":"Feb 23 2019",
		"settings":{
				"name": id,
				"img": img,
				"desc": desc,
				"color":"indigo",
				"graphics":[]
		}
		}
		
		console.log('YOYOYO    activity is now '+JSON.stringify(activity));
		store.set({activity: activity})
			
			
		},
		addGoogleData(id,settings,activities, graphics, dateRaw) {
			let h2 = document.getElementsByTagName('h2')[0] || document.getElementsByTagName('h1')[0] ;
			h2 = h2.innerHTML;
			let d;
			if (settings) {
				d = settings.desc;
			}
			
			let imgs = [];
			let imgTags = document.getElementsByClassName('card');
			if (graphics && graphics.length > 0) {
				for (let img of graphics){
					if (img.includes('.zip')) continue;
					imgs.push(`https://talker.netlify.com/img/activities/${ settings.name }/${img}.png`);
				}
				if (imgTags.length > 0) {
				for (let img2 of imgTags) {
					let src = img2.getAttribute('src');
					let arr = src.split('/');
					let lenny = arr.length - 1;
					let filen = arr[lenny]
					imgs.push(`https://talker.netlify.com/img/activities/${filen}`);
				}
				}
			}
			let data = {
			  "@context": "https://schema.org",
			  "@type": "NewsArticle",
			  "mainEntityOfPage": {
				"@type": "WebPage",
				"@id": "https://google.com/article"
			  }, 
			  "headline": h2,
			  "image": imgs,
			  "datePublished": dateRaw,
			  "dateModified": dateRaw,
			  "author": {
				"@type": "Person",
				"name": "Stacey Reiman"
			  },
			   "publisher": {
				"@type": "Organization",
				"name": "Talker AAC",
				"logo": {
				  "@type": "ImageObject",
				  "url": "https://talker.netlify.com/img/talker_symbols/go.png"
				} 
			  },  
			  "description": d
			};
 
			var s = document.createElement('script');
			s.type = 'application/ld+json';
			s.text = JSON.stringify(data);
			//s.onload = callback;
			let m = document.getElementsByTagName('head')[0];
			if (m){
				console.log(m)
				m.appendChild(s);
			}
			
			
		},
		addActivities(main,id,activities) {
			let graphics;
			let comp =  this;
			let dateRaw;
			let mainCol = 'red';
			let settings;
						
			//console.log('activities: '+JSON.stringify(activities));
			/* loop through activities to find the graphics for this one */
			 
			for (let activity of activities) {
				
				if (activity.settings.name == id.replace('activities/', '')) {
					graphics = activity.settings.graphics;
					settings = activity.settings;
					dateRaw = activity.dateRaw;
					mainCol = activity.settings.color;
					console.log('# ACTIVITY ' +JSON.stringify(activity));
					store.set({activity:activity})
				}
			}
			
					//let's add a table  to main now
			let divs = `<h2>Downloadable Graphics</h2><p>Right click and select "Save Image As" to download any image below. To download a zip file of these images,<a href="../img/${id}/${settings.name}.zip"><b> click here. </b></a> Copyright © Stacey Reiman 2019, free for non-commercial use.`;
			for (let img of graphics) {
				
				if (img.includes('.zip')) continue;
				
				divs+= `<div class="thumby"> <img class="thumb"  src="../img/${id}/${img}.png"> </div>`
			}
			let div = `<div>${divs}</div>`;
			
			main.insertAdjacentHTML('beforeend',div);
			
			// color our main header for activities
			
		
			let ah = document.getElementsByClassName('activityHeader')[0];
			if (ah) ah.style.backgroundColor = mainCol;			
			
			
			comp.addH2Tags(); 
			comp.addGoogleData(id,settings,activities, graphics, dateRaw);
		},
		getActivities(main,id) {
		  let comp = this;
		  const urly = './../activities.json';
			fetch(urly)
			.then(res => res.json())
			.then(activities => {
				
			comp.addActivities(main,id,activities);
			const lesson = document.getElementsByTagName('h2')[0];
			lesson.style.marginTop = '100px';
		})
		},
	    goto(path) {
			roadtrip.goto(path);
		},
		addListings() {
			console.log('running listings fn');
			
		
		},
		scrollTag(id) {
			const elmnt = document.getElementById(id);
			elmnt.scrollIntoView();	
		},
		addH2Tags() {
			const lesson = document.getElementsByClassName('lesson')[0];
			const tags = lesson.getElementsByTagName('h2');
			let i = 0;
			let arr = [];
			for (let tag of tags) {
				let tagId = 'h2_'+i;
				/*
				let h = `<a id="${tagId}">${tag.innerHTML}</a>`
				console.log(h)
				tag.innerHTML = h;
				*/
				tag.id = tagId;
				i++;
				arr.push({text: tag.textContent, id: tagId });	
			}
			this.set({ lessonTags: arr });
		}
    },
	computed: {
		colors: ( { $sectionColors, $id }) => {
			return $sectionColors[$id]
		},
		snips: ( { $snippets, $id } ) => {
        /* could not figure out how to chaing these ! :(  */
			  $snippets.map((snip,idx) => { 
				snip.idx = idx;
			  })
			  return $snippets.filter((snip,idx) => snip.cat === $id);
		},
		details: ({ $id, $cats }) => {
		 return $cats.filter(category => category[0] === $id)[0];
		}
	},

	oncreate() {
		const state = store.get();
		const id = state.id;
		let postsRoute = false;
		
		let pathname = state.params;
		
		console.log('pathname is '+pathname);
		
		if (pathname.includes('topics')) {
			postsRoute = true;
			
		}
		let activities = state.activities;

		
			
		const comp = this;
		const elmnt = document.getElementById("postWrap");
		elmnt.scrollIntoView();	
	
		
		const urly = `../posts/${ id }.html`;
		
		return fetch(urly).then(function(res) {
		return res.text();
			})
			.then(function(html) {
				html = html.replace(/[\r\n\t]/g, '');
				html = html.replace(/@@/g, '\n');
				//html = html.replace(/<\/pre>/g, '</pre><div class="cns"></div')
				comp.set({'desc':html});

			//	console.log(`html = ${html}`);
			//	Prism.highlightAll();

			/* add the consoles to each code block, then we add ids so we can
			grab the code to pass to the code runner */ 
				
				
				/* adds our bg colors to spans so we have colorful headings in sections */

				const sections = document.querySelectorAll('.lesson > p > span');
				/* section colors that are too light for white text */document
				const lightCols = ['rgb(236, 240, 32)','rgb(255, 208, 113)'];

				if (id == "listings") {
					//comp.addListings();
				}
			let mainCol = 'red';
			
			const main = document.getElementsByClassName('lesson')[0];
		
				
		/* 
		!!!   README   !!!!!
		
		kind of quirky but in case our activities are not loaded yet, user comes in off web on this url, 
		i have to only add the H2 tags once the data is there. So for activities, we check for data, then 
		do what we need, THEN add the H2Tags after data retrieval . The only reason we have to have that JSON file rather 
		than just our data-settings is because only Node.js can iterate through the folder and write the filenames to JSON*/
		
			
				//console.log('id is '+JSON.stringify(state.params));
				if (!id.includes('activities') && postsRoute ) {
	
					comp.addH2Tags(); 
					
					comp.createSettings(id);
				}
				else {
					if (!activities) {
						comp.getActivities(main,id)
					}	
					else {
						comp.addActivities(main,id,activities);
					}
							
				}
				//console.table(settings)
			//	console.log('settings.color is '+settings.color);
				
				sections.forEach(function(section) {
					let { colors } = comp.get();
					if (!colors) colors = {};
					let col = colors.color1 || mainCol;
					
					
					section.style.backgroundColor = col;

					if (lightCols.includes(col)){
						section.style.color = '#000'
					}
					//section.insertAdjacentHTML('beforeBegin', '<hr />');
				});
			});

		}
}
</script>